//import { DotNet } from "./DotNet";
//import { PtJsHelper } from "./PtJsHelper";


//declare global {
//  interface Window {
//    webkitAudioContext: typeof AudioContext;
//    __JsHelper: PtJsHelper;
//  }
//}

//declare module globalThis {
//  let __JsHelper: PtJsHelper;
//}

//globalThis.__JsHelper = new PtJsHelper();
//window.__JsHelper = globalThis.__JsHelper;

console.log("Hello aa.aw.client.blazor.aspnetcore.net.bundle.js World!");
